export default {
	/*设置是否显示商品订货价格*/
  setIsscanprice(state, isscanprice) {
  	state.isscanprice = isscanprice
  },
  /*设置是否启用商城开放注册*/
  setIsscan(state, isscan) {
  	state.isscan = isscan
  },
  /*设置商户开放的购买方式权限*/
  setOpenPurchaseConfig(state, data) {
  	state.openpurchase = data
  },
  /*设置购物车数量*/
  setShoppingCartQty(state, data) {
    state.shoppingCartQty = data.toString()
  },
  /*设置商户开票信息*/
  setTicketTypesData(state, ticketTypesData) {
    state.ticketTypesData = ticketTypesData
  },
  /*设置商户小数点*/
  setDigit(state, {qtyDigit, priceDigit}) {
    state.qtyDigit = qtyDigit
    state.priceDigit = priceDigit
  },
  /*设置商户信息*/
  setGetsellerCompanyInfo(state, sellerCompanyInfo) {
    state.sellerCompanyInfo = sellerCompanyInfo
  },
  /*设置主题相关*/
  setThemeConfig(state, {themeFlag, isHasLoading, loadingTime, adImg}) {
    state.themeFlag = themeFlag
    state.isHasLoading = isHasLoading
    state.loadingTime = loadingTime
    state.adImg = adImg
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js